<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<v-btn
									color="red"
									class="px-0"
									height="auto"
									exact
									x-large
									text
									:to="{name: `${locationName}-hub`}"
								>
									รวมโครงการ{{ location }}
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span v-if="params.category === 'singlehome'">
									บ้านเดี่ยว
								</span>
								<span v-else-if="params.category === 'townhome'">
									ทาวน์โฮม
								</span>
								<span v-else-if="params.category === 'condo'">
									คอนโด
								</span>
								<span v-else-if="params.category === 'shophouse'">
									อาคารพาณิชย์
								</span>
							</div>
							<div class="search-filter">
								<h1>
									รวมโครงการ{{ location }}
								</h1>

								<div class="pl-3 pr-5">
									<h2 v-if="params.category === 'singlehome'">
										บ้านเดี่ยว
									</h2>
									<h2 v-else-if="params.category === 'townhome'">
										ทาวน์โฮม
									</h2>
									<h2 v-else-if="params.category === 'condo'">
										คอนโด
									</h2>
									<h2 v-else-if="params.category === 'shophouse'">
										อาคารพาณิชย์
									</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container>
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="d-flex">
							<div class="px-4">
								<img
									:src="`/images/2.0/icon/${params.category}_i.png`"
									width="64"
								>
							</div>
							<div class="py-4">
								<template v-if="content === 'singlehome'">
									<h1 class="red--text">
										รวมอสังหาฯ บ้านเดี่ยวนนทบุรี ราคาถูก บ้านเดี่ยวมือสองนนทบุรี บ้านจัดสรร ซื้อ ขาย
									</h1>
									<p class="mt-4">
										สำหรับคนที่มองหาบ้านนนทบุรี ไม่ว่าจะเป็นบ้านเดี่ยวนนทบุรี บ้านมือสองนนทบุรี หรือบ้านจัดสรรนนทบุรี สามารถเลือกซื้อ ขาย และค้นหาโครงการบ้านนนทบุรีได้ผ่านระบบซื้อ-ขายแบบครบวงจร พร้อมฝากขายบ้านกับเรา The Best Property ที่จะช่วยดูแลการขายให้จบ ครบทุกขั้นตอนเริ่มตั้งแต่การทำการตลาดไปจนถึงการปิดการขาย นอกจากนี้ยังมีระบบคำนวณสินเชื่อที่ช่วยให้คุณตัดสินใจเลือกซื้อบ้านนนทบุรีได้ตรงใจที่สุด
									</p>
								</template>

								<template v-else-if="content === 'townhome'">
									<h1 class="red--text">
										รวมประกาศ ซื้อ ขาย อสังหาฯ ทาวน์โฮมนนทบุรี ทาวน์เฮ้าส์  มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										ใครที่สนใจจะซื้อ-ขายทาวน์โฮมนนทบุรี หรือทาวน์เฮ้าส์มือสองนนทบุรี แต่ยังไม่เจอหลังที่ถูกใจ หรือทำเลที่เหมาะกับการใช้ชีวิต แนะนำให้ลองค้นหา townhome townhouse กับเรา พร้อมคำนวณสินเชื่อด้วยโปรแกรมใช้งานฟรีที่นี่ที่เดียว หรือต้องการฝากขายบ้านทาวน์โฮมนนทบุรี ทาวน์เฮ้าส์นนทบุรีในย่านต่างๆ เช่น ท่าอิฐ, ชัยพฤกษ์, ปากเกร็ด, บางใหญ่, บางบัวทอง ฯลฯ เราก็มีบริการนายหน้ารับฝากขายให้ครบวงจร
									</p>
								</template>

								<template v-else-if="content === 'condo'">
									<h1 class="red--text">
										รวมประกาศ ซื้อ ขาย อสังหาฯ คอนโดนนทบุรี คอนโดมิเนียม มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										รวมประกาศซื้อ-ขายคอนโดนนทบุรี ทั้งคอนโดมือสองราคาถูกนนทบุรี คอนโดพร้อมอยู่นนทบุรี คอนโดติดรถไฟฟ้านนทบุรี มีตั้งแต่คอนโดราคาล้านต้นๆ ในหลากหลายทำเล เช่น ชัยพฤกษ์ ปากเกร็ด บางกรวย ท่าอิฐ เป็นต้น ทำให้ผู้คนมากมายเริ่มให้ความสนใจที่จะมาลงทุนในจังหวัดมากขึ้น ซึ่งคุณพิจารณาได้จาก Segment คอนโด และทำเลได้เลยในเว็บไซต์ของเรา พร้อมลองคำนวณสินเชื่อก่อนทำการกู้ซื้อคอนโดได้เลยในที่เดียว
									</p>
								</template>

								<template v-else-if="content === 'shophouse'">
									<h1 class="red--text">
										รวมอสังหาฯ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์นนทบุรี ตึกแถว มือสอง ราคาถูก
									</h1>
									<p class="mt-4">
										รวมอสังหาฯ ให้เช่า ขายอาคารพาณิชย์นนทบุรี ตึกแถวให้เช่านนทบุรี ทั้งอาคารพาณิชย์ชั้นเดียวหรืออาคารพาณิชย์ 2 ชั้นทุกพื้นที่ในนนทบุรี สามารค้นหาอาคารพาณิชย์ ตึกแถวสภาพดีในทำเลที่คุณต้องการ ไม่ว่าจะเป็นการเช่า-ซื้อ-ขาย-เซ้งตึกแถวหรืออาคารพาณิชย์ในนนทบุรีด้วยตนเองหรือผ่านตัวแทน โดย THE BEST PROPERTY มีบริการนายหน้ามืออาชีพแบบครบวงจร พร้อมกับโปรแกรมคำนวณสินเชื่อก่อนกู้ซื้อได้แบบฟรีๆ
									</p>
								</template>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="category-menu mx-auto px-4 py-8 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'singlehome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'singlehome'}}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'townhome'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'townhome'}}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'condo'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'condo'}}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									:class="{'current-page': params.category === 'shophouse'}"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'shophouse'}}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-6">
			<v-container class="px-6 py-0">
				<v-row no-gutters>
					<v-col
						ref="top"
						xl="8"
						class="mx-auto"
					>
						<div
							v-if="area"
							class="text-center red--text mt-n8 pb-4"
							style="position: relative;"
						>
							<b>เลือกทำเล</b>
						</div>
						<v-slide-group
							v-model="areaSelected"
							center-active
							show-arrows
						>
							<template #next>
								<v-icon color="rgb(237,28,36)">
									$next
								</v-icon>
							</template>
							<template #prev>
								<v-icon color="rgb(237,28,36)">
									$prev
								</v-icon>
							</template>

							<v-slide-item
								v-for="(a, i) in area"
								:key="`${locationName}-${i}`"
								:value="a.value"
							>
								<v-btn
									class="area mr-2 pa-2"
									elevation="0"
									text
									tile
									:to="a.path"
								>
									{{ a.text }}
								</v-btn>
							</v-slide-item>
						</v-slide-group>

						<v-row class="mt-3">
							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-end pl-md-0 pr-md-6"
							>
								<div class="d-flex justify-center align-center">
									<img
										src="/images/2.0/icon/bed-red.png"
										width="40"
									>
									<b class="mx-3">จำนวนห้องนอน</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 1 } }"
									>
										1
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 2 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 3 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, minbeds: 4 } }"
									>
										4
									</v-btn>
								</div>
							</v-col>

							<v-col
								cols="12"
								sm="6"
								class="d-md-flex justify-md-start pl-md-6 pr-md-0"
							>
								<div class="d-flex justify-center  align-center">
									<img
										src="/images/2.0/icon/money-red.png"
										width="40"
									>
									<b class="mx-3">ราคาไม่เกิน(ล้านบาท)</b>
								</div>
								<div class="widget-btn d-flex justify-center align-center mt-3 mt-md-0">
									<v-btn
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 2000000 } }"
									>
										2
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 3000000 } }"
									>
										3
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 4000000 } }"
									>
										4
									</v-btn>
									<v-btn
										class="ml-2"
										outlined
										min-width="unset"
										:to="{ name: 'lists', query: { ...widgetQuery, maxprice: 5000000 } }"
									>
										5
									</v-btn>
								</div>
							</v-col>
						</v-row>

						<div
							v-if="empty"
							class="text-center display-3"
						>
							<br><br>
							ไม่พบข้อมูล
							<br><br><br>
						</div>
						<v-row v-else>
							<v-col
								cols="12"
								class="pt-6 pb-4 text-center"
							>
								<h2>
									<span>อสังหา</span>
									<span
										v-if="params.category === 'singlehome'"
										class="red--text"
									>
										บ้านเดี่ยว{{ location }}
									</span>
									<span
										v-else-if="params.category === 'townhome'"
										class="red--text"
									>
										ทาวน์โฮม{{ location }}
									</span>
									<span
										v-else-if="params.category === 'condo'"
										class="red--text"
									>
										คอนโด{{ location }}
									</span>
									<span
										v-else-if="params.category === 'shophouse'"
										class="red--text"
									>
										อาคารพาณิชย์{{ location }}
									</span>
								</h2>
							</v-col>
							<v-col
								v-for="(prop, i) in loading ? parseInt(perPage) : propertyList"
								:key="prop.id || i"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<propertyListItemSkeleton v-if="loading" />
								<propertyListItem
									v-else
									:id="prop.id"
								/>
							</v-col>

							<v-col
								cols="12"
								class="px-0 px-md-3"
							>
								<div class="d-flex justify-center justify-md-space-between align-center mx-n3 px-md-3 text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<template v-if="content === 'singlehome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ บ้านเดี่ยวนนทบุรี โซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> ประกอบด้วย 7 เขตพื้นที่ได้แก่ ไทรน้อย ราษฎร์นิยม หนองเพรางาย ไทรใหญ่ ขุนศรี คลองขวางและทวีวัฒนา ซึ่งเป็นทำเลชานเมือง ทำให้บ้านเดี่ยวราคาถูกนนทบุรีกระจุกตัวอยู่ในทำเลนี้เป็นจำนวนมาก โดยระดับราคาจะอยู่ที่ประมาณ 3-4 ล้านบาท หรือบางโครงการซึ่งเป็นโครงการเก่า อาจหาซื้อบ้านเดี่ยวในระดับราคา 2 ล้านกลางๆ ก็เป็นไปได้ ราคานี้น่าจะถูกที่สุดแล้วเมื่อเทียบกับทำเลชานเมืองกรุงเทพฯ อื่นๆ
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> สำหรับทำเลบางบัวทองเดิม เป็นพื้นที่ที่ครอบคลุม 3 อำเภอ ได้แก่ อ.ไทรน้อย อ.บางใหญ่ และ อ.ปากเกร็ด แต่ปัจจุบันได้แยกตัวแล้ว แต่ด้วยความที่เป็นทำเลฮอตจากการก่อสร้างรถไฟฟ้าและทำถนนสายใหม่ๆ ทำให้ราคาที่ดินติดถนนใหญ่ พุ่งไปแตะหลักแสนกว่าถึงสองแสนบาทแล้ว ทำให้ราคาบ้านเดี่ยวนนทบุรีในย่านนี้ มีราคาไม่เกิน 3 ไปจนถึงราคาไม่เกิน 5 ล้านบาท
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> ประกอบไปด้วย บางม่วง บางแม่นาง บางเลน เสาธงหิน บางใหญ่และบ้านใหม่ เนื่องจากเป็นทำเลที่คนกรุงเทพฯ น่าจะรู้จักกันดี ด้วยเป็นที่ตั้งของ Central Plaza Westgate และ IKEA บางใหญ่ ทำให้หลายคนสนใจย้ายมาซื้อ-ขายบ้านนนทบุรีในย่านนี้กันมากขึ้น โดยราคาบ้านเดี่ยวมือสองนนทบุรีในทำเลนี้จะอยู่ที่ประมาณราคาไม่เกิน 5 ล้านบาท ไปจนถึงราคาไม่เกิน 7 ล้านบาท
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> ประกอบด้วย 9 ตำบลได้แก่ วัดชลอ บางกรวย คูเวียง บางสีทอง บางขนุน บางขุนกอง บางคูเวียง มหาสวัสดิ์ ปลายบางและศาลากลาง เป็นอีกหนึ่งทำเลใหญ่ที่กินพื้นที่หลายตำบลทำให้ราคาบ้านเดี่ยวนนทบุรีในโซนนี้มีราคาหลากหลาย ตั้งแต่ 2-10 ล้านบาท ขึ้นอยู่กับทำเลที่ตั้งและขนาดของบ้านเป็นหลัก
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> ประกอบด้วย 10 ตำบล ได้แก่ สวนใหญ่ ตลาดขวัญ บางเขน บางกระสอ ท่าทราย บางไผ่ บางศรีเมือง บางกร่าง ไทรม้าและบางรักน้อย เนื่องจากเป็นตัวเมืองที่มีความคึกคัก ทำให้มีดีมานด์สูง ราคาบ้านมือสองแถวนนทบุรีจะมีราคาเริ่มต้น 4 ล้านบาทขึ้นไป แต่ก็คุ้มค่าและเหมาะสำหรับคนที่ต้องการสิ่งอำนวยความสะดวกและเดินทางง่ายเป็นหลัก
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> ประกอบด้วย 12 ตำบลได้แก่ ปากเกร็ด บางตลาด บ้านใหม่ บางพูด บางตะไนต์ คลองพระอุดม ท่าอิฐ เกาะเกร็ด อ้อมเกร็ด คลองข่อย บางพลับและคลองเกลือ ซึ่งนับเป็นย่านท่องเที่ยวและอยู่อาศัยขนาดใหญ่ ทำให้โครงการบ้านเดี่ยวนนทบุรีในย่านนี้มีราคาหลากหลาย แต่ก็ยังอยู่ในโซนที่ยังจับต้องได้อยู่ โดยที่บ้านเดี่ยวมือสองนนทบุรี ทาวน์โฮม ทาวน์เฮ้าส์จะ เริ่มต้นที่ 2-3 ล้านบาทขึ้นไป จึงเหมาะสำหรับคนที่อยากมีบ้านในราคาที่ไม่แพงมากนักและอยู่ในทำเลที่มีศักยภาพพัฒนาได้ดี
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกบ้านเดี่ยวนนทบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-2">
									ทำเลที่อยู่อาศัยการเลือกซื้อบ้านเดี่ยวนนทบุรี
								</h3>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> ถือเป็นอีกหนึ่งทำเลชานเมืองของจังหวัดนนทบุรีที่ได้รับความนิยมในการซื้อ-ขายบ้านราคาถูกนนทบุรี เนื่องจากมีการเจริญเติบโตในภาพรวมทั้งด้านโครงสร้างพื้นฐานในการใช้ชีวิตทั้งรถไฟฟ้าที่วิ่งตัดผ่านในพื้นที่จังหวัดนนทบุรี และถนนที่ตอนนี้ใช้วิ่งได้ทั้งฝั่งเข้าและออกเมือง โดยสามารถเชื่อมไปยังนครปฐม สุพรรณบุรี อยุธยา ปทุมธานี รวมถึงสิ่งอำนวยความสะดวกอื่นๆ ก็ผุดขึ้นมามากมายในย่านนี้ด้วยเช่นเดียวกัน
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> เป็นทำเลที่ได้รับอานิสงส์จากการขยายตัวของเขตเมืองชั้นในที่หนาแน่น บวกกับการเล็งเห็นศักยภาพในการเป็นประตูเมืองเพื่อเปิดรับ AEC ทำให้มีระบบขนส่งมวลชน ระบบสาธารณูปโภค และระบบเส้นทางการคมนาคมอีกหลายเส้นทางให้สะดวกสบายยิ่งขึ้น อาทิ ทางหลวงพิเศษ 81 (ถนนมอเตอร์เวย์) เส้นบางใหญ่-กาญจนบุรี ที่ในอนาคตจะเชื่อมเส้นทางจากเมืองไทยกับพม่าเข้าด้วยกัน ทำให้เป็นทำเลศักยภาพที่จะกลายเป็น HUB การอยู่อาศัย เป็นแหล่งงาน ออฟฟิศใหม่ๆ คอมมูนิตี้มอลล์ และห้างสรรพสินค้าขนาดใหญ่รวมถึงมีรถไฟฟ้าสายสีม่วงตัดผ่านอีกด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> โดดเด่นในเรื่องโดดเด่นของการเติบโตของคอมมูนิตี้มอลล์ชั้นนำ ที่ได้รวบรวมแหล่งช้อปปิ้ง, ร้านอาหารยอดนิยม และแหล่งบริการด้านความบันเทิงไว้อีกมากมายไม่ว่าจะเป็นอิเกีย บางใหญ่, เซ็นทรัล เวสต์เกต ซูเปอร์รีจินัล มอลล์, PlusMall บางใหญ่ รวมถึงบิ๊กซี, โลตัส ส่วนการเดินทางก็จะมีรถไฟฟ้าสายสีม่วงที่วิ่งผ่านจากเตาปูน-บางใหญ่ เชื่อมต่อสายสีน้ำเงินที่สถานีเตาปูนสามารถเชื่อมต่อไปยัง MRT บางซื่อ และ BTS สายสีเขียวเข้มหรือสายสุขุมวิทที่มุ่งหน้าเข้าสู่ตัวเมืองได้แบบไม่ต้องกังวลเรื่องรถติด
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> นับเป็น Sub Location ที่มีการพัฒนาโครงการหมู่บ้านนนทบุรีขึ้นมาเป็นจำนวนมาก เนื่องจากเป็นทำเลใหม่ที่ได้รับอิทธิพลความเจริญจากการมาของรถไฟฟ้าสายสีม่วง เตาปูน-บางใหญ่ ทำให้การเดินทางสะดวกมากขึ้น ด้านถนนหนทางก็ขยายออกเป็น 4 เลน และเดินทางไปถนนสายสำคัญได้หลากหลาย เช่น ถนนรัตนาธิเบศร์ ถนนนนทบุรี 1 ส่วนสิ่งอำนวยความสะดวกก็มีครบ เพราะเป็นย่านชุมชน ทั้งตลาดสดใหญ่ โรงเรียนชื่อดัง ร้านค้าปลีกย่อย ร้านอาหาร รวมไปถึงร้านสะดวกซื้อด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> ถ้าต้องการตัวเลือกที่ดีที่สุดสำหรับคนที่มองหาบ้านนนทบุรี ใกล้เมือง หลีกหนีความวุ่นวายจากกรุงเทพฯ มาใช้ชีวิตอย่างสงบ แน่นอนว่า การเลือกหมู่บ้านแถวนนทบุรี คือหนึ่งในคำตอบที่ใช่ เนื่องจากในปัจจุบันนี้มีทั้งแหล่งชอปปิง แหล่งไลฟ์สไตล์ต่างๆ และเรื่องการเดินทางที่สะดวกกว่าเมื่อก่อนมาก จากการมาของรถไฟฟ้าเข้าถึง 2 สายทั้งสายม่วงและสายสีชมพู ทางด่วนศรีรัช-กาญจนาฯที่ทำให้การเดินทางเข้าเมืองเป็นเรื่องง่ายดายมากขึ้นนั่นเอง
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> เป็นย่านชุมชนที่มีสถานที่อำนวยความสะดวกครบครัน จึงเหมาะที่จะซื้อ-ขายบ้านเดี่ยวนนทบุรีในย่านนี้เป็นอย่างมาก แถมยังเป็นทำเลที่เติบโตอยู่อย่างต่อเนื่อง สังเกตได้จากการมีศูนย์บริการ สถานที่สำหรับทำงาน รวมถึงแลนด์มาร์กสำหรับผ่อนคลายในวันหยุด ที่คุณสามารถไปแฮงเอาท์ หรือเที่ยวเล่นได้โดยที่ไม่ต้องขับรถฝ่ารถติดเข้าไปในใจกลางเมืองให้เสียเวลา อีกทั้งด้านการเดินทางเองก็มีรถไฟฟ้าสายสีม่วง ซึ่งเชื่อมต่อกับรถไฟฟ้าสายสีชมพู โดยแนวรถไฟฟ้าจะผ่านสถานที่สำคัญ ผ่านถนนเล็กใหญ่ต่างๆ ไปเชื่อมกับรถไฟฟ้าสายสีแดงที่เขตหลักสี่ และเชื่อมกับรถไฟฟ้าสายสีเขียว ทำให้การเข้า-ออกเมืองสะดวกมากขึ้นอีกด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'townhome'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ บ้าน ทาวน์เฮ้าส์ ทาวน์โฮมนนทบุรี โซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> เป็นทำเลที่อยู่อาศัยที่มีความเจริญสลับกันกับพื้นที่เกษตรกรรมอย่างการทำนา ทำให้ราคาทาวน์โฮมนนทบุรี และทาวน์เฮ้าส์ราคาถูกนนทบุรีจัดอยู่ในเรตราคาที่เอื้อมถึง โดยสามารถหาทาวน์โฮมหรือทาวน์เฮ้าส์ในราคาไม่เกิน 8 แสน หรือราคาไม่เกินล้านได้อยู่ จึงตอบโจทย์สำหรับคนที่เริ่มต้นอยากมีบ้านในเขตพื้นที่ไทรน้อย ราษฎร์นิยม หนองเพรางาย ไทรใหญ่ ขุนศรี คลองขวางและทวีวัฒนาเป็นอย่างมาก
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> เป็นพื้นที่ที่ครอบคลุม 3 อำเภอ ได้แก่ อ.ไทรน้อย อ.บางใหญ่ และ อ.ปากเกร็ด แต่ปัจจุบันได้แยกตัวแล้ว แต่ก็ยังเป็นทำเลฮอตของคนที่มักจะตามหา ทาวน์โฮมหรือทาวน์เฮ้าส์มือสองนนทบุรีราคาถูกที่อยู่ในย่านของความเจริญ โดยยังสามารถหาบ้านทาวน์โฮมมือสองหรือทาวน์เฮ้าส์ราคาถูกนนทบุรีในราคาไม่เกิน 1.5 ล้าน หรือราคาไม่เกิน 2 ล้านบาทได้อยู่
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> ประกอบด้วย 9 ตำบลได้แก่ วัดชลอ บางกรวย คูเวียง บางสีทอง บางขนุน บางขุนกอง บางคูเวียง มหาสวัสดิ์ ปลายบางและศาลากลาง ซึ่งมีโครงการบ้านนนทบุรีค่อนข้างมากและยังได้รับการพัฒนาอย่างต่อเนื่อง โดยเรตราคาทาวน์โฮมนนทบุรีไม่เกิน 2 ล้านบาทยังสามารถจะหาได้จากย่านนี้อยู่ แต่ทั้งนี้ก็ขึ้นอยู่กับทำเลและสภาพของตัวบ้านด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> ถือเป็นทำเลที่เจริญมากในจังหวัดนนทบุรี เนื่องจากเป็นที่ตั้งของห้างและ Mega project มากมาย ทำให้ย่านนี้มีที่อยู่อาศัยอยู่หลายประเภท และหลากหลายเรตราคา โดยจะมีราคาเริ่มต้นอยู่ที่ 1-7 ล้านบาท ขึ้นอยู่กับพื้นที่ตั้ง วัสดุ การตกแต่ง ไปจนถึงทำเลที่ตั้ง โดยในโซนบางใหญ่นี้จะประกอบไปด้วยบางม่วง บางแม่นาง บางเลน เสาธงหิน บางใหญ่และบ้านใหม่
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> ประกอบด้วย 10 ตำบล ได้แก่ สวนใหญ่ ตลาดขวัญ บางเขน บางกระสอ ท่าทราย บางไผ่ บางศรีเมือง บางกร่าง ไทรม้าและบางรักน้อย โดยบ้านและทาวน์โฮมจะกระจุกตัวอยู่ที่สถานีบางกระสอ สถานีไทรม้า และสถานีบางรักน้อยท่าอิฐมากที่สุด มีราคาอยู่ที่ตั้งแต่ 2-10 ล้านบาท เนื่องจากมีทำเลที่กว้างทำให้มีเรตราคาที่แตกต่างกันไปด้วย
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> เป็นทำเลท่องเที่ยวและที่อยู่อาศัย ประกอบด้วย10 ตำบล ได้แก่ สวนใหญ่ ตลาดขวัญ บางเขน บางกระสอ ท่าทราย บางไผ่ บางศรีเมือง บางกร่าง ไทรม้าและบางรักน้อย โดยส่วนใหญ่จะยึดโยงความเจริญไว้ที่บริเวณถนนแจ้งวัฒนะและถนนติวานนท์เป็นหลัก ทำให้ทาวน์โฮมนนทบุรีในย่านนี้มีราคาไม่เกิน 4 ล้านบาท ส่วนราคาขายทาวน์เฮ้าส์นนทบุรีจะมีราคาต่ำกว่าอาจหาได้ในราคาไม่เกิน 2 ล้าน หรือราคาไม่เกิน 3 ล้านบาท ทั้งนี้ ก็ขึ้นอยู่กับขนาดและพื้นที่ทำเลด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกอสังหาฯ ทาวน์เฮ้าส์ ทาวน์โฮมนนทบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ทำเลที่อยู่อาศัยการเลือกซื้ออสังหาฯ ทาวน์เฮ้าส์ ทาวน์โฮมนนทบุรี
								</h3>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> เป็นอำเภอที่น่าจะไกลจากตัวเมืองนนทบุรีที่สุด ผสมผสานระหว่างชุมชนเดิม พื้นที่เกษตรกรรมและที่อยู่อาศัยมาใหม่ เรียกว่าเป็นพื้นที่รองรับความเจริญจากโซนบางใหญ่ที่อยู่ไม่ไกลกันก็ว่าได้ จึงเหมาะสำหรับคนที่ชอบความสงบ เน้นการอยู่อาศัยแบบเป็นส่วนตัว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												ส่วนถ้าต้องการจับจ่ายใช้สอยก็สามารถมาเดินเล่นที่ห้างสรรพสินค้า เช่น เซ็นทรัลเวสต์เกส อีเกียบางใหญ่ หรือไปซื้อของสดได้ที่ตลาดบางใหญ่ก็ได้เช่นกัน ด้านการเดินทางสถานีรถไฟฟ้าที่ใกล้ที่สุดจะเป็นสถานีคลองบางไผ่ แต่ต้องต่อรถโดยสารมาอีกหนึ่งจึงจะถึงโซนไทรน้อย หรือถ้าขับรถส่วนตัวก็สามารถวิ่งตรงไปยังถนนแจ้งวัฒนะ เพื่อเข้าเมืองได้ หรือถ้าออกเมืองจะอยู่ใกล้กับโซนอยุธยาและสุพรรณบุรี
											</p>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> ใครที่ต้องการซื้อ-ขายโครงการทาวน์เฮ้าส์ใหม่นนทบุรี หรือหาทาวน์โฮมแถวนนทบุรี ทำเลบางบัวทองดูจะเป็นทำเลฮิตของจังหวัดนี้ เพราะเป็น Sub Center ของการอยู่อาศัย การเดินทาง และการใช้ชีวิตทั้งชอป ชิม ชิลล์
											</p>
											<p class="mt-2 mb-0">
												โดยมีถ.กาญจนาภิเษก ซึ่งถือเป็นถนนสายหลักที่เชื่อมต่อบางบัวทอง กับถนนหลายสายได้รอบทิศทาง นอกจากนี้ก็มีเส้นทางด่วนที่สะดวกสบาย คือ ทางด่วนพิเศษศรีรัช-วงแหวนรอบนอกฯ เป็นจุดเชื่อมต่อกับถนนสายหลัก และเชื่อมกับทางพิเศษรวมถึง 8 แห่ง ทำให้การไปไหนมาไหนทำได้สะดวกและรวดเร็วมากทีเดียว อีกทั้ง ยังอยู่ไม่ไกลจากรถไฟฟ้าสถานีคลองบางไผ่อีกด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> ป็นย่านที่กำลังพัฒนาไปอีกขั้นด้วยการเป็น Regional Gateway ที่ใหญ่ที่สุดของกรุงเทพฯตะวันตก จากการพัฒนาโครงการถนนมอเตอร์เวย์ บางใหญ่-กาญจนบุรี กับโครงการทางด่วนพิเศษสายศรีรัช – วงแหวนรอบนอกกรุงเทพมหานคร อีกทั้งยังมีการเดินทางรถไฟฟ้าสายสีม่วง และศูนย์การค้าขนาดใหญ่ เซ็นทรัลเวสต์เกต ทำให้ทำเลย่านนี้คึกคักและจะกลายเป็น Hub ที่อยู่อาศัยใหญ่ในอนาคตแน่นอน
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> สำหรับผู้อยู่อาศัยทาวน์โฮมนนทบุรีย่านบางกรวย นอกจากถนนเส้นกาญจนาที่ทำให้เดินทางสัญจรสะดวกแล้ว ยังมีห้างสรรพสินค้าชื่อดังเป็นแหล่งพักผ่อนหย่อนใจหลายแห่ง รวมถึงร้านอาหารอีกมากมาย จึงเป็นทำเลแห่งไลฟ์สไตล์ของนนทบุรีที่มีทั้งความสงบในด้านความเป็นชุมชน และการเป็นสถานที่ท่องเที่ยวที่มีทั้งในรูปแบบครึกครื้น รวมถึงการท่องเที่ยวแบบอนุรักษ์ตามแบบฉบับชุมชนดั้งเดิมด้วย
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> นับเป็นศูนย์รวมสถานที่สำคัญหลายแห่ง ไม่ว่าจะเป็น สำนักงานบริษัทเอกชน ศูนย์ราชการ สถานศึกษา สถานพยาบาล ศูนย์การค้า ศูนย์ประชุมใหญ่ และแหล่งท่องเที่ยวไลฟ์สไตล์ รวมถึงเป็นย่านที่รถไฟฟ้าสายสีม่วงช่วงเตาปูน-คลองบางไผ่ตัดผ่าน ทำให้ย่านนี้ เรียกได้ว่า บางโซนพื้นที่ CBD ของนนทบุรีเลยทีเดียว จึงเหมาะสำหรับคนที่ต้องการอยู่ในพื้นที่ความเจริญของจังหวัดนนทบุรี เดินทางง่าย และเข้าถึงสิ่งอำนวยความสะดวกได้อย่างรวดเร็วเป็นหลัก
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> อำเภอปากเกร็ดตั้งอยู่ติดกับเขตดอนเมือง จึงเป็นอีกหนึ่งจุดที่เชื่อมต่อเข้า-ออกเมืองที่สะดวกสบายอีกแห่ง นอกจากนี้ภายในอำเภอปากเกร็ดนั้น ยังประกอบไปด้วยหมู่บ้านจัดสรร บ้านทาวน์เฮ้าส์นนทบุรีมากมาย เพื่อรองรับการขยายตัวของเมืองอย่างต่อเนื่อง อีกทั้งด้านการเดินทางเองก็มีรถไฟฟ้าสายสีม่วง ซึ่งเชื่อมต่อกับรถไฟฟ้าสายสีชมพู ทำให้การอยู่อาศัยในย่านนี้เหมาะกับการอยู่อาศัยสำหรับคนที่เข้า+ออกเมืองหรือทำงานอยู่ในเขตสนามบินเป็นหลัก
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'condo'">
							<h2 class="red--text">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคาอสังหาฯ คอนโดนนทบุรี ในโซนต่างๆ
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> เป็นทำเลที่อยู่อาศัยและเกษตรกรรม ประกอบด้วยโซนราษฎร์นิยม หนองเพรางาย ไทรใหญ่ ขุนศรี คลองขวางและทวีวัฒนา ซึ่งเป็นโซนที่เชื่อมต่อกับบางกรวย บางบัวทอง และยังสามารถเชื่อมต่อไปยังสุพรรณบุรีและปทุมธานีอีกด้วย จึงเป็นทำเลซื้อ-ขายคอนโดนนทบุรีสำหรับคนที่ต้องการได้ที่อยู่อาศัยในราคาที่เอื้อมถึงมีหมดทั้งราคาไม่เกิน 3 แสน ราคาไม่เกิน 1 ล้าน ราคาไม่เกิน 2 ล้านบาท
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> เนื่องจากเป็นทำเลของแหล่งไลฟ์สไตล์แบบคนเมือง จึงทำให้มีที่อยู่อาศัยรูปแบบใหม่อย่างคอนโดมิเนียมนนทบุรี ทั้งเกาะแนวรถไฟฟ้าและในตรอกซอกซอยอยู่หลายโครงการ แน่นอนว่า ด้วยความเจริญก็ทำให้ราคาที่ดินแพงขึ้น โดยทำเลติดถนนใหญ่พุ่งไปแตะหลักแสนกว่าถึงสองแสนบาท/ตารางเมตรแล้วในปัจจุบัน แต่ก็ยังมีโซนอื่นๆ ที่อยู่ตามซอยต่างๆ ให้จับจองอยู่เช่นกัน ทำให้ราคาขายของคอนโดในย่านเฉลี่ยอยู่ที่ 9 แสน - 1 ล้านต้นๆ เท่านั้น
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> จะแบ่งออกเป็น 9 ตำบลได้แก่ วัดชลอ บางกรวย คูเวียง บางสีทอง บางขนุน บางขุนกอง บางคูเวียง มหาสวัสดิ์ ปลายบางและศาลากลาง เรตราคาคอนโดจะไม่ได้แพงมากเช่นเดียวกันกับย่านไทรน้อยที่อยู่ใกล้เคียง โดยยังสามารถหาคอนโดนนทบุรีล้านต้นๆ ได้อยู่ แต่ก็มีความเจริญที่มองเห็นศักยภาพพัฒนาได้ค่อนข้างมากเนื่องจากรับความเจริญจากโซนบางหใญ่ บางบัวทองเป็นหลัก
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> คอนโดมิเนียมนนทบุรีในโซนบางใหญ่ จะมีราคาเริ่มต้นเฉลี่ยอยู่ที่ 1-1.2 ล้านบาท เนื่องจากมีคอนโดมิเนียมเกิดขึ้นในโซนนี้เป็นจำนวนมากในทุกโซน ได้แก่ โซนบางม่วง บางแม่นาง บางเลน เสาธงหิน บางใหญ่และบ้านใหม่ ทำให้มีการแข่งขันด้านการขายสูง แต่เมื่อมีการขยายตัวของ Mega Project ถนนหนทาง ไปจนถึงการเชื่อมต่อรถไฟฟ้าหลากสี ก็จะทำให้ย่านนี้มีราคาของ condo นนทบุรี ที่สูงขึ้นตามมาได้ เมื่อจำนวนยูนิตที่มีอยู่ขายไปหมดแล้ว
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> เนื่องจากเป็นบริเวณที่มีสถานที่ราชการ โรงแรม และถนนที่เชื่อมต่อใกล้กับกรุงเทพมหานคร และคอนโดส่วนใหญ่เป็นคอนโดมีเชื่อเสียงจากดีเวลลอปเปอร์เจ้าดัง ทำให้ราคาคอนโดในโซนเมืองนนทบุรีมีราคาสูงเฉลี่ยอยู่ที่ประมาณ 1,500,000 บาท – 3,000,000 บาท โดยโซนนี้จะประกอบไปด้วย 10 ตำบล ดังนี้ สวนใหญ่ ตลาดขวัญ บางเขน บางกระสอ ท่าทราย บางไผ่ บางศรีเมือง บางกร่าง ไทรม้าและบางรักน้อย
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> ด้วยทำเลศักยภาพไม่ไกลจากตัวเมืองแบบนี้ ประกอบกับแวดล้อมไปด้วยความสะดวกมากมาย อีกทั้งเป็นย่านท่องเที่ยวและกินพื้นที่ในหลายตำบล ได้แก่ สวนใหญ่ ตลาดขวัญ บางเขน บางกระสอ ท่าทราย บางไผ่ บางศรีเมือง บางกร่าง ไทรม้าและบางรักน้อย ทำให้ราคาคอนโดนนทบุรีในโซนนี้ เริ่มต้นอยู่ที่ 1 ล้านบาทต้นๆ ซึ่งก็ยังถือว่าเป็นราคาจับต้องได้อยู่สำหรับคนรุ่นใหม่
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกคอนโดแถวนนทบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ทำเลที่อยู่อาศัยการเลือกซื้อคอนโดนนทบุรี
								</h3>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> เป็นทำเลที่มีความสะดวกสำหรับการใช้ชีวิตแบบผสมผสาน เพราะทำเลส่วนใหญ่จะเป็นพื้นที่เกษตรกรรมที่มีชุมชนดั้งเดิมอยู่รายล้อม อีกทั้ง ยังเป็นทำเลที่อยู่ห่างจากตัวเมืองนนทบุรีมากที่สุด จึงเป็นเหมือนกับทำเลรองรับความเจริญที่ค่อยๆ กระจายตัวออกมาจากย่านบางใหญ่ ซึ่งก็อยู่ไม่ไกลกันมากนัก
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												ดังนั้น การเลือกซื้อคอนโดในย่านนนทบุรีในโซนไทรน้อยจึงเหมาะกับคนที่อยากได้คอนโดนนทบุรีไม่เกินล้าน  เน้นการรอการเติบโตของที่ดินในย่านใหม่ และใช้ชีวิตด้วยรถส่วนตัวเป็นหลัก เพราะเป็นทำเลที่เดินทางสะดวก สามารถวิ่งตรงไปยังถนนแจ้งวัฒนะ เพื่อเข้าเมืองได้ หรือถ้าออกเมืองจะอยู่ใกล้กับโซนอยุธยาและสุพรรณบุรี หรือถ้าต้องการใช้รถไฟฟ้าก็มีสายสีม่วงอยู่ไม่ไกล โดยสถานีที่ใกล้ที่สุดคือ สถานีคลองบางไผ่
											</p>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> เป็นทำเลที่อยู่อาศัยของจังหวัดนนทบุรีเลยก็ว่าได้ ค่อนข้างมีสิ่งอำนวยความสะดวกครบในทุกๆ ด้าน เช่น โรงเรียน โรงพยาบาล ห้างสรรพสินค้า คาเฟ่ ร้านอาหาร แถมการเดินทางก็สะดวกอยู่ใกล้กับ ทางด่วนพิเศษศรีรัช-วงแหวนรอบนอกฯ เป็นจุดเชื่อมต่อกับถนนสายหลัก และเชื่อมกับทางพิเศษรวมถึง 8 แห่ง ทำให้มีคนอยู่ในโซนนี้มาก จึงเหมาะกับคนที่ชอบความครึกครื้น สนใจลงทุนซื้อคอนโดนนทบุรีในโซนที่มีความเจริญแล้ว อาจจะเพื่ออยู่อาศัยหรือปล่อยเช่าก็ได้
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> เป็นพื้นที่อยู่อาศัยอีกแห่งที่ราคาคอนโดยังเอื้อมถึง เนื่องจากมีไลฟ์สไตล์ในด้านทำเลที่ยังอยู่ในรูปแบบผสมผสานเช่นเดียวกันกับทำเลไทรน้อย แต่มีความเจริญด้านแหล่งจับจ่ายซื้อของที่มากขึ้นมาอีกนิด แต่ก็ยังสามารถตอบโจทย์ทุก Lifestyle การอยู่อาศัยบนพื้นที่ส่วนตัว บนทำเลรอบนอกที่ใกล้ชิดธรรมชาติ แต่ก็ยังสะดวกสบายด้วยสิ่งอำนวยความสะดวกครบครัน พร้อมเชื่อมต่อการเดินทางได้อย่างหลากหลายไปด้วยในตัว
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> เป็นทำเลฮอตของนนทบุรีที่มีทั้งห้างสรรพสินค้าขนาดใหญ่ เช่น เซ็นทรัลเวสต์เกต อีเกียบางใหญ่ และศูนย์การค้าอื่นๆ อีกมากมาย มีตลาดสดขนาดใหญ่ในทำเล ร้านอาหาร ร้านค้า คาเฟ่ และสถานที่ท่องเที่ยวเชิงธรรมชาติอื่นๆ นอกจากนี้ยังมีรถไฟฟ้าสายสีม่วง เตาปูน-คลองบางไผ่ตัดผ่านหลายสถานี เช่น สถานีตลาดบางใหญ่ ทำให้ทำเลนี้ยิ่งคึกคัก การซื้อคอนโดแถวนนทบุรีในย่านนี้จึงเหมาะกับคนที่สนใจทำเลที่เจริญแล้วเป็นหลัก มองหาสิ่งอำนวยความสะดวกคล้ายในตัวเมือง หรือสนใจซื้อไว้สำหรับปล่อยเช่า
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> เป็นศูนย์กลางของสถานที่สำคัญหลายแห่ง ทั้งสำนักงานบริษัทเอกชน ศูนย์ราชการ สถานศึกษา สถานพยาบาล ศูนย์การค้า ศูนย์ประชุมใหญ่ และแหล่งท่องเที่ยว ทำให้เป็นทำเลของแหล่งงานและที่อยู่อาศัยที่คึกคักมากที่สุดของจังหวัด บวกกับการเข้า-ออกเมืองที่ทำได้ง่ายสำหรับผู้อยู่อาศัยคอนโดนนทบุรี ทั้งการใช้รถส่วนตัวและรถไฟฟ้าสายสีม่วงที่เชื่อมต่อกับ MRT สายสีน้ำเงิน ทำให้เหมาะมากสำหรับคนที่ทำงานอยู่ในตัวเมืองนนทบุรีหรือกรุงเทพมหานคร
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> เป็นทำเลท่องเที่ยวที่ทั้งชาวไทยและชาวต่างชาตินิยมเดินทางมาเยือน นอกจากนี้ยังอยู่ใกล้กับเขตดอนเมือง ซึ่งเป็นเขตอากาศยานทำให้กลายเป็นพื้นที่เชิงอนุรักษ์สำหรับการท่องเที่ยวและการอยู่อาศัยที่มีเสน่ห์และมีคนพลุกพล่านอยู่ตลอด จึงเหมาะกับคนที่ต้องการการเดินทางที่สะดวกสบายในงบประมาณที่เอื้อมถึง และยังสามารถใช้วันหยุดใกล้ชิดกับธรรมชาติพื้นที่สีเขียวไปพร้อมกันได้ด้วย
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>

						<!--  -->
						<template v-if="content === 'shophouse'">
							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/price-tag-bk.png"
									height="25"
									class="mr-2"
								>
								รวมราคา ซื้อ-ขายอาคารพาณิชย์นนทบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> เป็นย่านที่มีพื้นที่ส่วนใหญ่เป็นพื้นที่เกษตรกรรม ทำให้โครงการอาคารพาณิชย์ในพื้นที่มีราคาไม่สูงมากนัก โดยจะอยู่ที่ 2 ล้านขึ้นไป (ขึ้นอยู่กับทำเลในพื้นที่ด้วยว่าอยู่ในโซนไหน) โดยไทรน้อยจะแบ่งออกเป็น 7 ตำบล ได้แก่ ไทรน้อย ราษฎร์นิยม หนองเพรางาย ไทรใหญ่ ขุนศรี คลองขวางและทวีวัฒนา ซึ่งในพื้นที่คึกคักอย่างตัวเมืองและเป็นอาคารพาณิชย์สภาพดี อาจมีราคาสูงได้ถึง 7 ล้านบาทขึ้นไปเลยทีเดียว
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> เป็นย่านที่รองรับการอยู่อาศัย จึงมีการซื้อ-ขายอาคารพาณิชย์นนทบุรีในพื้นที่นี้จำนวนมากตามดีมานด์ของพื้นที่ โดยราคาในพื้นที่จะเริ่มต้นอยู่ที่ 3 ล้านบาทขึ้นไป ขึ้นอยู่กับทำเล ซึ่งสำหรับพื้นที่บางบังทองนั้นจะประกอบไปด้วย 8 ตำบลได้แก่ โสนลอย บางบัวทอง บางรักใหญ่ บางคูรัด ละหาร ลำโพ พิมลราชและบางรักพัฒนา โดยในพื้นที่ที่มีดีมานด์สูงนั้นราคาอาจสูงถึง 10 ล้านบาทขึ้นไปเลยทีเดียว
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> เป็นพื้นที่รองรับการขยายตัวจากบางบัวทอง ทำให้มีการพัฒนาพื้นที่หลายแห่ง เช่น เซ็นทรัล เวสต์เกต ซึ่งส่งผลให้ราคาซื้อ-ขายอาคารพาณิชย์นนทบุรีมีการปรับขึ้นอยู่บ้าง ขึ้นอยู่กับทำเลที่ได้รับการพัฒนา โดยบางใหญ่จะมีการแบ่งพื้นที่ ดังนี้ ตำบลบางม่วง บางแม่นาง บางเลน เสาธงหิน บางใหญ่และบ้านใหม่ ในส่วนของราคาการซื้อ-ขายอาคารพาณิชย์ในทำเลบางใหญ่จะเริ่มต้นที่ 3 ล้านบาทในพื้นที่ที่ไม่ค่อยคึกคัก แต่หากเป็นพื้นที่ที่มีดีมานด์สูงจะขึ้นไปถึง 10 ล้านบาทขึ้นไปได้เลย
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> เป็นทำเลที่อยู่ติดกับกรุงเทพส่วนหนึ่งจึงมีการพัฒนาเป็นที่อยู่อาศัยรองรับการขยายตัวของกรุงเทพซึ่งทำให้ราคาของการซื้อ-ขายอาคารพาณิชย์นนทบุรี บางกรวยมีการปรับตัวสูงแต่ยังไม่เท่าบางใหญ่ (ขึ้นอยู่กับแต่ละทำเลที่มีการพัฒนา) โดยบางกรวยจะแบ่งพื้นที่เป็น 9 ตำบล ได้แก่ วัดชลอ บางกรวย คูเวียง บางสีทอง บางขนุน บางขุนกอง บางคูเวียง มหาสวัสดิ์ ปลายบางและศาลากลาง ซึ่งราคาซื้อ-ขายอาคารพาณิชย์จะเริ่มต้นที่ 4 ล้านขึ้นไป
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> นับเป็นพื้นที่ใจกลางของนนทบุรีที่มีการพัฒนาสูงที่สุดในจังหวัด ทำให้มีดีมานด์ในการซื้ออสังหาริมทรัพย์ทั้งที่พักอาศัยและอาคารพาณิชย์ค่อนข้างสูงตามไปด้วย โดยเมืองนนทบุรีจะมีการแบ่งพื้นที่ตามเขตตำบล ดังนี้ ตำบลสวนใหญ่ ตลาดขวัญ บางเขน บางกระสอ ท่าทราย บางไผ่ บางศรีเมือง บางกร่าง ไทรม้าและบางรักน้อย ซึ่งแต่ละพื้นที่จะมีการซื้อ-ขายอาคารพาณิชย์ในราคาที่ต่างกัน เริ่มต้นตั้งแต่ 4 ล้านและอาจสูงไปถึง 20 ล้านได้เลยขึ้นอยู่กับทำเลที่ตั้งและสภาพของอาคาร รวมถึงพื้นที่ใช้สอยในอาคารด้วยเช่นกัน
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> เป็นอำเภอที่ถูกแบ่งพื้นที่ออกเป็นสองส่วน ทำให้มีการพัฒนาที่แตกต่างกันอย่างเห็นได้ชัดซึ่งส่งผลกับราคาการซื้อ-ขายอาคารพาณิชย์ด้วยเช่นกัน โดยปากเกร็ดจะมีการแบ่งพื้นที่ทั้งหมด 12 ตำบล ได้แก่ ปากเกร็ด บางตลาด บ้านใหม่ บางพูด บางตะไนต์ คลองพระอุดม ท่าอิฐ เกาะเกร็ด อ้อมเกร็ด คลองข่อย บางพลับและคลองเกลือ สำหรับราคาอาคารพาณิชย์นนทบุรี ปากเกร็ดนี้จะเริ่มต้นที่ 3 ล้านบาทขึ้นไป
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>

							<h2 class="red--text mt-8">
								<img
									src="/images/2.0/icon/idea-bk.png"
									height="25"
									class="mr-2"
								>
								วิธีการเลือกอาคารพาณิชย์ในนนทบุรี
							</h2>
							<v-card
								class="pa-4 mt-4 mx-md-0 area-content"
								flat
								tile
							>
								<h3 class="mt-3">
									ทำเลที่อยู่อาศัยการเลือกซื้ออาคารพาณิชย์นนทบุรี
								</h3>
								<p class="mt-2 mb-0">
									<b>ไทรน้อย</b> เป็นอำเภอที่เพิ่งได้รับการแยกตัวออกมาได้ไม่นาน และมีพื้นที่ส่วนใหญ่เป็นพื้นที่สำหรับเกษตรกรรมและปศุสัตว์ จึงค่อนข้างเงียบสงบ หากต้องการลงทุนซื้อ-ขายอาคารพาณิชย์นนทบุรีในทำเลไทรน้อยนี้จะมีราคาค่อนข้างต่ำว่าทำเลอื่นๆ ในนนทบุรี จึงเหมาะสำหรับคนที่ต้องการอาคารพาณิชย์เพื่อทำกิจการ เช่น ร้านอาหาร ร้านขายของชำ ร้านเครื่องเขียน เพราะผู้คนที่อาศัยในพื้นที่ส่วนใหญ่เป็นการพักอาศัยเป็นหลัก
								</p>

								<v-expansion-panels flat>
									<v-expansion-panel>
										<v-expansion-panel-header>
											<span>อ่านเพิ่มเติม</span>
											<template v-slot:actions>
												<v-icon color="rgb(237,28,36)">
													$expand
												</v-icon>
											</template>
										</v-expansion-panel-header>
										<v-expansion-panel-content eager>
											<p class="mt-2 mb-0">
												<b>บางบัวทอง</b> เป็นทำเลที่มีการพัฒนาค่อนข้างมากทีเดียว จึงมีทั้งการซื้อ-ขายอาคารพาณิชย์นนทบุรีเพื่อเป็นอาคารสำนักงาน ร้านค้า คาเฟ่ โรงเรียนกวดวิชาและอื่นๆ ทำให้การซื้อ-ขายอาคารพาณิชย์ค่อนข้างคึกคักโดยเฉพาะพื้นที่ใกล้กับรถไฟฟ้าสายสีม่วง สถานีปลายทางคลองบางไผ่ ซึ่งนับว่าอยู่ไม่ไกลจากศูนย์การค้าเซ็นทรัล เวสต์เกต ทำให้มีคนสัญจรค่อนข้างมาก
											</p>
											<p class="mt-2 mb-0">
												<b>บางใหญ่</b> เป็นย่านที่สามารถแบ่งครึ่งเป็นสองส่วนคือ ส่วนที่ได้รับอิทธิพลการพัฒนาพื้นที่จากเมืองนนทบุรี ทำให้มีพัฒนาอาคารพาณิชย์และที่พักอาศัยมากขึ้นตามไปด้วย ดังนั้น ในส่วนนี้จึงเหมาะสำหรับการทำกิจการร้านค้า ส่วนอีกครึ่งหนึ่งนั้นเป็นพื้นที่การเกษตรที่ค่อนข้างเงียบสงบการซื้อ-ขายอาคารพาณิชย์ในทำเลนี้จึงเหมาะสำหรับการทำกิจการเพื่อคนในชุมชนซึ่งส่วนใหญ่จะเป็นกิจการเกี่ยวกับการเกษตรกรรมเป็นหลัก
											</p>
											<p class="mt-2 mb-0">
												<b>บางกรวย</b> เรียกได้ว่า เป็นพื้นที่พัฒนาเพื่อการเป็นทำเลรองรับการอยู่อาศัยเสียส่วนใหญ่จึงมีโครงการหมู่บ้านและที่พักอาศัยต่างๆ มากมายด้วยเช่นกัน ดังนั้น การซื้อ-ขายอาคารพาณิชย์นนทบุรี บางกรวยจึงพัฒนาเพื่อทำกิจการเกี่ยวกับการใช้ชีวิต เช่น ร้านอาหาร และร้านขายของใช้ในครัวเรือนเป็นส่วนใหญ่ โดยเฉพาะพื้นที่ใกล้ตลาดจะมีอาคารพาณิชย์เปิดกิจการมากเป็นพิเศษทีเดียว
											</p>
											<p class="mt-2 mb-0">
												<b>เมืองนนทบุรี</b> สำหรับในโซนนี้ได้รับการพัฒนามากที่สุดในนนทบุรี ทำให้การซื้อ-ขายอาคารพาณิชย์ค่อนข้างคึกคักและมีการเปิดซื้อ-ขายอาคารพาณิชย์นนทบุรีเพื่อทำกิจการที่หลากหลายมากขึ้น มีทั้งการเปิดเพื่อทำกิจการร้านอาหาร คาเฟ่ และอาคารสำนักงานต่างๆ รวมถึงกิจการอื่นๆ อีกมากมายโดยเฉพาะในพื้นที่ใกล้รถไฟฟ้า ซึ่งจะมีทั้งศูนย์การค้าและแหล่งไลฟ์สไตล์อื่นๆ ด้วยเช่นกัน
											</p>
											<p class="mt-2">
												<b>ปากเกร็ด</b> นับเป็นพื้นที่ค่อนข้างหลากหลาย เพราะมีทั้งพื้นที่ธรรมชาติและพื้นที่เมือง ทำให้การซื้อ-ขายอาคารพาณิชย์ในพื้นที่ชุมชนจะค่อนข้างคึกคักมากกว่าฝั่งธรรมชาติ แต่ถึงอย่างนั้นในทำเลปากเกร็ดนี้ยังมีแหล่งท่องเที่ยวอย่างเกาะเกร็ดที่ทำให้การเปิดกิจการในพื้นที่จะค่อนข้างหลากหลายมากขึ้น เพราะมีทั้งโซนร้านอาหาร โซนอาคารสำนักงานและโซนที่เปิดเพื่อรองรับนักท่องเที่ยวไว้มากมายเลยทีเดียว
											</p>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card>
						</template>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'search'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyListItem from '~/components/2.0/property-list-item'
import propertyListItemSkeleton from '~/components/2.0/property-list-item-skeleton'

export default {
	// scrollToTop: true,
	name: 'LIST',
	layout: 'default_2',

	components: {
		searchForm,
		propertyListItem,
		propertyListItemSkeleton
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let params = context.params
		let content = params.area || params.category || null
		let query = {}
		let widgetQuery = {}

		// const market_selected = params.category === 'singlehome' ? 'HOME' : params.category === 'townhome' ? 'TOWNHOUSE' : params.category === 'condo' ? 'CONDO' : 'COMMERCIAL_BUILDING'

		// Category
		const province = 3
		if (content === 'singlehome') {
			data['title'] = 'รวมอสังหาฯ บ้านเดี่ยวนนทบุรี ราคาถูก บ้านเดี่ยวมือสองนนทบุรี บ้านจัดสรร ซื้อ ขาย'
			data['description'] = 'รวมประกาศขายบ้าน บ้านเดี่ยวนนทบุรี ปี 2565 หมู่บ้าน บ้านจัดสรร บ้านเดี่ยวมือสองเมืองนนทบุรี พร้อมที่ดิน ซื้อ ขาย ราคาถูก'

			query = widgetQuery = {
				province,
				market_selected: 'HOME'
			}
		}
		else if (content === 'townhome') {
			data['title'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ ทาวน์โฮมนนทบุรี ทาวน์เฮ้าส์  มือสอง ราคาถูก'
			data['description'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ บ้านทาวน์โฮมนนทบุรี ทาวน์เฮ้าส์แถวนนทบุรี Townhome Townhouse มือสอง ราคาถูก พร้อมอยู่'

			query = widgetQuery = {
				province,
				market_selected: 'TOWNHOUSE'
			}
		}
		else if (content === 'condo') {
			data['title'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ คอนโดนนทบุรี คอนโดมิเนียม มือสอง ราคาถูก'
			data['description'] = 'รวมประกาศ ซื้อ ขาย อสังหาฯ คอนโดนนทบุรี คอนโดมิเนียมนนทบุรี มือสอง Condo ราคาถูก ล้านต้นๆ ติดรถไฟฟ้า ทำเลดี พร้อมอยู่ มีให้เลือกทุกแบบ'

			query = widgetQuery = {
				province,
				market_selected: 'CONDO'
			}
		}
		else if (content === 'shophouse') {
			data['title'] = 'รวมอสังหาฯ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์นนทบุรี ตึกแถว มือสอง ราคาถูก'
			data['description'] = 'รวมอสังหาฯ ให้เช่า เซ้ง ซื้อ ขายอาคารพาณิชย์นนทบุรี ตึกแถว บ้านตึก มือสอง ทำเลดี ราคาถูก บางใหญ่ บางบัวทอง ปากเกร็ด ไทรน้อย พร้อมรายละเอียด'

			query = widgetQuery = {
				province,
				market_selected: 'COMMERCIAL_BUILDING'
			}
		}

		widgetQuery = { ...query }

		await context.store.dispatch('page/initial', data)

		return {
			params, content, query, widgetQuery,
			areaSelected: params.area,
			location: 'นนทบุรี',
			locationName: 'nonthaburi',
		}
	},

	data:() => ({
		keepAliveActivated: false,
		loading: true,
		empty: false,
		perPage: 12,
		propertyList: [],
		queryTxt: '',
		page: 1,
		total: 0,
	}),

	computed: {
		...mapGetters({
			getProperty: 'property/getProperty',
			head: 'page/head',
		}),

		bannerImg () {
			return '/images/2.0/all-project-banner.jpg'
		},

		category () {
			if (this.content || this.content && ['singlehome','townhome','condo', 'shophouse'].includes(this.content)) {
				return [
					{ text: 'บ้านเดี่ยว', path: `/${this.locationName}/singlehome` },
					{ text: 'ทาวน์โฮม', path:  `/${this.locationName}/townhome` },
					{ text: 'คอนโด', path:  `/${this.locationName}/condo` },
					{ text: 'อาคารพาณิชย์', path:  `/${this.locationName}/shophouse` },
				]
			}

			return null
		},

		area () {
			if (this.content && [
				'singlehome', // 'townhome','condo', 'shophouse',
			].includes(this.content)) {
				return null
			}

			return null
		},

		totalPage () {
			return Math.ceil(this.total / this.perPage)
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},
	},

	watch: {
		page (newPage) {
			// this.$refs.top.scrollIntoView({ /*behavior: 'smooth',*/ block: 'center' })
			this.$refs.top.scrollIntoView({ behavior: 'smooth', block: 'end' })

			this.query.page = newPage
			this.search()
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			this.search()
		}
	},

	created() {
		if (process.client) {
			this.search()
		}
	},

	mounted() {

	},

	methods: {
		...mapActions({
			getPropertyList: 'property/getPropertyList',
			searchProperty: 'property/searchProperty'
		}),
		...mapMutations({
			searchToggle: 'page/searchToggle'
		}),

		search () {
			// if (this.loading) return
			this.loading = true
			this.propertyList = []
			this.total = 0
			// Call to store action for search with query (GET parameter)
			let params = {
				...this.query,
				ipp: this.perPage // item per page
			}

			this.$nextTick(() => {
				// window.scrollTo(0, 0)
				this.$refs.topPage.scrollIntoView({ behavior: 'smooth', block: 'end' })
			})

			this.searchProperty(params).then(propObj => {
				this.propertyList = propObj.propsList
				this.total = propObj.total
				this.queryTxt = propObj.queryTxt
				this.perPage = propObj.perPage

				this.empty = this.propertyList.length === 0
				this.page = parseInt(this.query.page) || 1
				this.loading = false
				this.keepAliveActivated = true
			})
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	padding: 32px 0 60px 0;

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgba(157,30,37,1);
	}

	.category-menu {
		position: relative;

		&::before {
			content: ' ';
			position: absolute;
			background: #fff;
			left: -24px;
			right: 0;
			top: -32px;
			bottom: -60px;
		}
		&::after {
			content: ' ';
			position: absolute;
			z-index: 0;
			width: 150vw;
			left: -84px;
			top: 0;
			bottom: 0;
			background: rgb(237,28,36);
		}

		& > div {
			position: relative;
			z-index: 1;
		}
	}
}
.area:hover, .area.v-btn--active {
	background-color: #3a3a3a;
	color: #fff;
}
.widget-btn .v-btn:hover {
	background-color: rgb(237,28,36);
	color: #fff;
	border-color: rgb(237,28,36);
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	p {
		text-indent: 30px;
	}

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
